import React from 'react';
import { workProcess } from '../data/mockData';

const HowWeWorkSection = () => {
  return (
    <section id="process" className="py-24 bg-cream-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-wine-500 mb-3">Our Process</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-wine-950 mb-4">
            How Trademark <span className="text-wine-600">Registration Works</span>
          </h2>
          <p className="text-stone-500">A streamlined process from consultation to final USPTO approval.</p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="hidden md:block absolute top-7 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-wine-200 via-gold-400 to-wine-200"></div>
          <div className="grid md:grid-cols-3 gap-8">
            {workProcess.map((step) => (
              <div key={step.id} className="relative text-center group">
                <div className="w-14 h-14 bg-wine-600 rounded-full flex items-center justify-center text-white text-lg font-bold mx-auto mb-6 relative z-10 group-hover:bg-gold-500 group-hover:text-wine-950 group-hover:scale-110 transition-all duration-300 shadow-lg shadow-wine-600/30">
                  {step.step}
                </div>
                <h3 className="text-lg font-semibold text-wine-950 mb-3 group-hover:text-wine-600 transition-colors">{step.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
